var CemeteryStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ApplicationSearchService } from "../../../view-application/shared/application-search.service";
import { map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiCemeteryConstants } from "../../constants/api-constants/api-cemetery.constants";
import { AlertType } from "../../models/alert";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { Router } from "@angular/router";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../../shared/utils/recipient-utils";
import { CreateBurialDetailsCmComponent } from "../../../create-application/modules/cm/create-burial-details-cm/create-burial-details-cm.component";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import { ViewFuneralParlourCmComponent } from "../../../view-application/modules/cm/view-funeral-parlour-cm/view-funeral-parlour-cm.component";
import { ViewFamilyMemberCmComponent } from "../../../view-application/modules/cm/view-family-member-cm/view-family-member-cm.component";
import { CreateFamilyMemberDetCmComponent } from "../../../create-application/modules/cm/create-family-member-det-cm/create-family-member-det-cm.component";
import { ViewDeceasedDetailsCmComponent } from "../../../view-application/modules/cm/view-deceased-details-cm/view-deceased-details-cm.component";
import { ViewBurialDetailsCmComponent } from "../../../view-application/modules/cm/view-burial-details-cm/view-burial-details-cm.component";
import { CreateDeceasedDetailsCmComponent } from "../../../create-application/modules/cm/create-deceased-details-cm/create-deceased-details-cm.component";
import { CreateFuneralParlourCmComponent } from "../../../create-application/modules/cm/create-funeral-parlour-cm/create-funeral-parlour-cm.component";
import { DeceasedDtailsCustomValidators } from "../../../create-application/modules/cm/shared/custom-validators";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
    ApplicationHeadingEnum["BurialDate"] = "Burial Date";
    ApplicationHeadingEnum["DateOfBirth"] = "Date Of Birth";
    ApplicationHeadingEnum["BurialOrderNumber"] = "Burial Order Number";
    ApplicationHeadingEnum["SerialNo"] = "Serial Number";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([[ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"], [ApplicationHeadingEnum.Applicant, "applicant"], [ApplicationHeadingEnum.Agent, "agent"], [ApplicationHeadingEnum.CreatedDate, "startDate"], [ApplicationHeadingEnum.ApplicationStatus, "phase"], [ApplicationHeadingEnum.DaysLeft, "daysLeft"], [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"], [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"], [ApplicationHeadingEnum.BurialDate, "burialDate"], [ApplicationHeadingEnum.DateOfBirth, "dateOfBirth"], [ApplicationHeadingEnum.BurialOrderNumber, "burialOrderNumber"], [ApplicationHeadingEnum.SerialNo, "serialNo"],]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
    ApplicationSummaryColumnsEnum["BurialDate"] = "Burial Date";
    ApplicationSummaryColumnsEnum["DateOfBirth"] = "Date Of Birth";
    ApplicationSummaryColumnsEnum["BurialOrderNumber"] = "Burial Order Number";
    ApplicationSummaryColumnsEnum["SerialNo"] = "Serial Number";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([[ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"], [ApplicationSummaryColumnsEnum.Applicant, "applicant"], [ApplicationSummaryColumnsEnum.Agent, "agent"], [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"], [ApplicationSummaryColumnsEnum.Phase, "phase"], [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"], [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"], [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"], [ApplicationSummaryColumnsEnum.BurialDate, "burialDate"], [ApplicationSummaryColumnsEnum.DateOfBirth, "dateOfBirth"], [ApplicationSummaryColumnsEnum.BurialOrderNumber, "burialOrderNumber"], [ApplicationSummaryColumnsEnum.SerialNo, "serialNo"],]);
export const CMExpandListForApplicationSearch = ApplicationSearchConstants.APP_EXPAND_PORTAL_APP_CM;
export var CreateApplicationCemeteryMenuHeadings;
(function (CreateApplicationCemeteryMenuHeadings) {
    CreateApplicationCemeteryMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationCemeteryMenuHeadings["BurialDetails"] = "Burial";
    CreateApplicationCemeteryMenuHeadings["DeceasedDetails"] = "Deceased";
    CreateApplicationCemeteryMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationCemeteryMenuHeadings["Agent"] = "Agent";
    CreateApplicationCemeteryMenuHeadings["FamilyMemberDetails"] = "Family member";
    CreateApplicationCemeteryMenuHeadings["FuneralParlour"] = "Funeral parlour";
    CreateApplicationCemeteryMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationCemeteryMenuHeadings || (CreateApplicationCemeteryMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["BurialDetails"] = "Burial details help";
    HeaderConfigurableTextTypes["DeceasedDetails"] = "Deceased details help";
    HeaderConfigurableTextTypes["FamilyMemberDetails"] = "Family member details help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Agent"] = "Agent help";
    HeaderConfigurableTextTypes["FuneralParlour"] = "Funeral parlour help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Summary"] = "Summary help";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationCemeteryMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationCemeteryMenuHeadings.BurialDetails, HeaderConfigurableTextTypes.BurialDetails)
    .set(CreateApplicationCemeteryMenuHeadings.DeceasedDetails, HeaderConfigurableTextTypes.DeceasedDetails)
    .set(CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails, HeaderConfigurableTextTypes.FamilyMemberDetails)
    .set(CreateApplicationCemeteryMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationCemeteryMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(CreateApplicationCemeteryMenuHeadings.FuneralParlour, HeaderConfigurableTextTypes.FuneralParlour)
    .set(CreateApplicationCemeteryMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationCemeteryMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Summary"] = "Summary";
    ViewApplicationMenuHeadings["BurialDetails"] = "Burial";
    ViewApplicationMenuHeadings["DeceasedDetails"] = "Deceased";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Agent"] = "Agent";
    ViewApplicationMenuHeadings["FamilyMemberDetails"] = "Family member";
    ViewApplicationMenuHeadings["FuneralParlour"] = "Funeral parlour";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewApplicationMenuConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Summary, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.BurialDetails, HeaderConfigurableTextTypes.BurialDetails)
    .set(ViewApplicationMenuHeadings.DeceasedDetails, HeaderConfigurableTextTypes.DeceasedDetails)
    .set(ViewApplicationMenuHeadings.FamilyMemberDetails, HeaderConfigurableTextTypes.FamilyMemberDetails)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.Agent, HeaderConfigurableTextTypes.Agent)
    .set(ViewApplicationMenuHeadings.FuneralParlour, HeaderConfigurableTextTypes.FuneralParlour)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export let CemeteryStrategyService = class CemeteryStrategyService extends AflaModuleStrategyService {
    static { CemeteryStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    http;
    appController;
    router;
    viewApplicationSteps = [];
    createApplicationMenuHeadings;
    viewApplicationComponentLookup;
    name = ModuleConfig.Cemetery;
    defaultSearchColumns;
    applicationEndpoint;
    createApplicationComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    applicationServiceUrl = ApiCemeteryConstants.URL;
    form;
    userId;
    moduleUsers;
    expandListForApplicationPartial = CMExpandListForApplicationSearch;
    lookups = new Map();
    createApplicationSteps = [];
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewApplicationMenuConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    statusColumn = "status/ workflowSection";
    savedApplication;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, http, appController, // private recipientSelectService: RecipientSelectService,
    router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = `${ApiCemeteryConstants.URL}/${ApiCemeteryConstants.FUNCTION_GET_MY_AFLA_PORTAL_CEMETERY_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationCemeteryMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(cast(${column.trim()},'Edm.String'),'${text.trim()}')`;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    // TODO Correct 2n arg: TPExpandListForApplicationPartial
    static buildExpand(params) {
        return params.set(ODataAction.Expand, CMExpandListForApplicationSearch);
    }
    buildListFilter(list, column) {
        const params = CemeteryStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    // TODO: Fix Application Search
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: CemeteryStrategyService_1.getRecipientName(CemeteryStrategyService_1.getFirstRecipient(application.applicant)),
            agent: CemeteryStrategyService_1.getRecipientName(CemeteryStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: this.saShortDatePipe.transform(application.createdDate),
            //  - do we need to do the same for the property name "phase" => "applicationStatus" for consistency?
            //  - don't forget to apply to all module services!!
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId,
            burialDate: "Burial Date",
            dateOfBirth: "Date Of Birth",
            burialOrderNumber: "Burial Order Number",
            serialNo: "Serial Number"
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([[ViewApplicationMenuHeadings.BurialDetails, ViewBurialDetailsCmComponent], [ViewApplicationMenuHeadings.DeceasedDetails, ViewDeceasedDetailsCmComponent], [ViewApplicationMenuHeadings.FamilyMemberDetails, ViewFamilyMemberCmComponent], [ViewApplicationMenuHeadings.FuneralParlour, ViewFuneralParlourCmComponent],]);
    }
    // TODO: setup correct component for each step
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([[CreateApplicationCemeteryMenuHeadings.BurialDetails, CreateBurialDetailsCmComponent,], [CreateApplicationCemeteryMenuHeadings.DeceasedDetails, CreateDeceasedDetailsCmComponent], [CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails, CreateFamilyMemberDetCmComponent], [CreateApplicationCemeteryMenuHeadings.FuneralParlour, CreateFuneralParlourCmComponent],]);
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = CemeteryStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, CemeteryStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.cleanupAfterDestroy(this.postApplicationService(application)).subscribe((savedApplication) => {
            this.appController.showMessage(CemeteryStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
            this.resetForm();
            this.router.navigate([AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")]).then();
        }, (error) => {
            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
        });
    }
    // TODO: Create the Build Step Methods for each step
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave = true) {
        // @ts-ignore
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationCemeteryMenuHeadings.BurialDetails.toLocaleLowerCase():
                application = this.buildBurialDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.DeceasedDetails.toLocaleLowerCase():
                application = this.buildDeceasedStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails.toLocaleLowerCase():
                application = this.buildFamilyMemberStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.Agent.toLocaleLowerCase():
                application = this.buildApplicantAgentStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.FuneralParlour.toLocaleLowerCase():
                application = this.buildFuneralParlourStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id > 0 ? application.id : 0;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                cmApplication: application,
                moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this as the saved application does not return with the updated family members
                    const params = {
                        $select: "family, deceased",
                        $expand: "family($expand=groups), deceased($expand=deceasedNames)",
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID} and deleted eq false`
                    };
                    this.cleanupAfterDestroy(this.getApplicationsQuery(params)).subscribe({
                        next: (response) => {
                            const family = response.value[0]?.family;
                            const deceased = response.value[0]?.deceased;
                            savedApplication.family = family;
                            savedApplication.deceased = deceased;
                            if (continueAfterSave && !savedApplication.eLodgementComplete) {
                                --savedApplication.eLodgementStep;
                            }
                            this.savedApplication = savedApplication;
                        }, error: (error) => {
                            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }, complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.appController.showMessage(CemeteryStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            else {
                                // NB: THIS WILL FIX ISSU WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IT YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.cmApplication.eLodgementStep;
                                // NB: DO NOT REMOVE THIS LINE UNLESS YOU HAVE A GOOD REASON! OTHERWISE, IT'S GOING TO CAUSE DUPLICATES!!!!
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(CemeteryStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }
                    });
                }, error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                },
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    // TODO Correct the routing here
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiCemeteryConstants.URL}/${applicationId}/${ApiCemeteryConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    // TODO Add steps
    getCurrentFormName(step) {
        if (step == null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationCemeteryMenuHeadings.BurialDetails.toLocaleLowerCase():
                formName = "burialForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.DeceasedDetails.toLocaleLowerCase():
                formName = "deceasedForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails.toLocaleLowerCase():
                formName = "familyMemberForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.Applicant.toLocaleLowerCase():
                this.requestStatusService.removeBusySpinner("CreateCMApplication");
                formName = "applicantForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.Agent.toLocaleLowerCase():
                this.requestStatusService.removeBusySpinner("CreateCMApplication");
                formName = "applicantAgentForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.FuneralParlour.toLocaleLowerCase():
                this.requestStatusService.removeBusySpinner("CreateCMApplication");
                formName = "funeralParlourForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    // TODO
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationCemeteryMenuHeadings.BurialDetails.toLocaleLowerCase():
                this.form.get("burialForm").get("type").reset();
                this.form.get("burialForm").get("burialDate").reset();
                this.form.get("burialForm").get("description").reset();
                break;
            case CreateApplicationCemeteryMenuHeadings.DeceasedDetails.toLocaleLowerCase():
                this.form.get("deceasedForm").get("sex").reset();
                this.form.get("deceasedForm").get("nationality").reset();
                this.form.get("deceasedForm").get("idNumber").reset();
                this.form.get("deceasedForm").get("idType").reset();
                this.form.get("deceasedForm").get("burialOrderNumber").reset();
                this.form.get("deceasedForm").get("serialNo").reset();
                this.form.get("deceasedForm").get("verticalPosition").reset();
                this.form.get("deceasedForm").get("dateOfBirth").reset();
                this.form.get("deceasedForm").get("dateOfDeath").reset();
                this.form.get("deceasedForm").get("placeOfBirth").reset();
                this.form.get("deceasedForm").get("placeOfDeath").reset();
                this.form.get("deceasedForm").get("maidenName").reset();
                this.form.get("deceasedForm").get("undertaker").reset();
                this.form.get("deceasedForm").get("provinceOfDeath").reset();
                this.form.get("deceasedForm").get("deceasedNames").reset();
                this.selectedApplicationService.clearDeceasedNamesTableSubject$.next(true);
                break;
            case CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails.toLocaleLowerCase():
                this.form.get("familyMemberForm").get("family").reset();
                break;
            case CreateApplicationCemeteryMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationCemeteryMenuHeadings.Agent.toLocaleLowerCase():
                this.form.get("applicantAgentForm").get("applicantAgentRecipient").reset();
                this.form.get("applicantAgentForm").get("applicantAgentIsNull").reset();
                break;
            case CreateApplicationCemeteryMenuHeadings.FuneralParlour.toLocaleLowerCase():
                this.form.get("funeralParlourForm").get("parlourRecipient").reset();
                this.form.get("funeralParlourForm").get("parlourSelector").reset();
                this.form.get("funeralParlourForm").get("funeralParlourIsNull").reset();
                break;
            case CreateApplicationCemeteryMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            default:
                break;
        }
    }
    resetForm() {
        this.form.reset();
    }
    // TODO correct the URL
    postApplicationService(params) {
        return this.http.post(ApiCemeteryConstants.URL, params);
    }
    // TODO: Remove unecessary fileds
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, lastEditedUser";
    }
    // TODO: Correct Constants
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_TP_APPLICATIONS_BY_USER;
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`,
                stepSubtitle: "",
                stepTitle: `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`,
                stepType: key === ViewApplicationMenuHeadings.Summary ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationCemeteryMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`,
                stepSubtitle: "",
                stepTitle: `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`,
                stepType: key === CreateApplicationCemeteryMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */,
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiCemeteryConstants.URL}/${jobId}/GetCmApplicationTypes`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        return true;
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    initForm() {
        this.form = new FormGroup({
            burialForm: new FormGroup({
                type: new FormControl(null, [Validators.required]),
                burialDate: new FormControl(null),
                description: new FormControl(null, [Validators.required])
            }), deceasedForm: new FormGroup({
                sex: new FormControl(null, [Validators.required]),
                nationality: new FormControl(null, [Validators.required]),
                idNumber: new FormControl(null, [Validators.required]),
                idType: new FormControl(null, [Validators.required]),
                burialOrderNumber: new FormControl(null, [Validators.required]),
                serialNo: new FormControl(null),
                verticalPosition: new FormControl(null, [Validators.required]),
                dateOfBirth: new FormControl(null, [Validators.required, DeceasedDtailsCustomValidators.CompareDateToToday]),
                dateOfDeath: new FormControl(null),
                placeOfBirth: new FormControl(null, [Validators.required]),
                placeOfDeath: new FormControl(null),
                maidenName: new FormControl(null),
                undertaker: new FormControl(null),
                provinceOfDeath: new FormControl(null),
                deceasedNames: new FormControl(null, [Validators.required]),
            }, DeceasedDtailsCustomValidators.CompareDateToDateOfDeath), familyMemberForm: new FormGroup({
                family: new FormControl(null),
            }), applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }), applicantAgentForm: new FormGroup({
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                applicantAgentIsNull: new FormControl(null),
            }), funeralParlourForm: new FormGroup({
                parlourRecipient: new FormControl(null, [Validators.required]),
                parlourSelector: new FormControl(null, [Validators.required]),
                funeralParlourIsNull: new FormControl(null),
            }), documentForm: new FormGroup({
                documents: new FormArray([]),
            }), detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]), referenceNumber: new FormControl(null),
            }),
        });
    }
    buildApplication(existingApplication) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        const application = {
            id: existingApplication ? existingApplication.id : 0,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            applicant: [applicant],
            applicantAgent: [],
            notes: [],
            eLodgementComplete: false,
            eLodgementStep: 0
        };
        return application;
    }
    buildBurialDetailsStep(stepIndex, existingApplication) {
        const burialFormValue = this.form.get("burialForm").value;
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.type = burialFormValue.type;
            application.burialDate = burialFormValue.burialDate;
            application.description = burialFormValue.description;
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
                type: burialFormValue.type,
                burialDate: burialFormValue.burialDate,
                description: burialFormValue.description
            };
        return application;
    }
    buildDeceasedStep(stepIndex, existingApplication) {
        const deceasedFormValue = this.form.get("deceasedForm").value;
        if (!existingApplication) {
            existingApplication = {
                id: 0, deleted: false, moduleId: Number(this.appController.selectedModuleID), eLodgementComplete: false,
            };
        }
        existingApplication.eLodgementStep = stepIndex;
        existingApplication.deceased = deceasedFormValue;
        if (!existingApplication.deceased.dateOfDeath)
            existingApplication.deceased.dateOfDeath = null;
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < existingApplication.deceased.deceasedNames.length; index++) {
            if (existingApplication.deceased.deceasedNames[index].id < 0)
                existingApplication.deceased.deceasedNames[index].id = 0;
        }
        return existingApplication;
    }
    buildFamilyMemberStep(stepIndex, existingApplication) {
        if (!existingApplication) {
            existingApplication = {
                id: 0, deleted: false, moduleId: Number(this.appController.selectedModuleID), eLodgementComplete: false,
            };
        }
        const familyMemberForm = this.form.get("familyMemberForm").value;
        if (familyMemberForm.hasOwnProperty("family")) {
            const familyMemberFormValue = familyMemberForm.family;
            for (let index = 0; index < familyMemberFormValue.length; index++) {
                if (familyMemberFormValue[index].id < 1) {
                    familyMemberFormValue[index].id = 0;
                }
                familyMemberFormValue[index] = RecipientUtils.removeInvalidRecipientProperties(familyMemberFormValue[index]);
            }
            const deletedMembers = [];
            // tslint:disable-next-line:prefer-for-of
            for (let index = 0; index < existingApplication.family.length; index++) {
                const family = familyMemberFormValue.find(f => f.id === existingApplication.family[index].id);
                if (!family) {
                    existingApplication.family[index].deleted = true;
                    deletedMembers.push(existingApplication.family[index]);
                }
            }
            existingApplication.eLodgementStep = stepIndex;
            existingApplication.family = familyMemberFormValue;
            existingApplication.family.push(...deletedMembers);
        }
        return existingApplication;
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        if (!applicant.id)
            applicant.id = 0;
        if (!existingApplication) {
            existingApplication = {
                id: 0, deleted: false, moduleId: Number(this.appController.selectedModuleID), eLodgementComplete: false,
            };
        }
        existingApplication.eLodgementStep = stepIndex;
        existingApplication.applicant = [applicant];
        return existingApplication;
    }
    buildApplicantAgentStep(stepIndex, existingApplication) {
        this.form.get("applicantAgentForm").get("applicantAgentRecipient").enable();
        const applicantAgentIsNullValue = this.form.get("applicantAgentForm").get("applicantAgentIsNull").value;
        const applicantAgentFormValue = this.form.get("applicantAgentForm").get("applicantAgentRecipient").value;
        const applicantAgent = RecipientUtils.removeInvalidRecipientProperties(applicantAgentFormValue);
        if (existingApplication) {
            existingApplication.applicantAgent = applicantAgentIsNullValue ? [] : [applicantAgent];
            existingApplication.applicantAgentNa = applicantAgentIsNullValue;
            existingApplication.eLodgementStep = stepIndex;
        }
        if (applicantAgentIsNullValue) {
            this.form.get("applicantAgentForm").get("applicantAgentRecipient").disable();
        }
        return existingApplication;
    }
    buildFuneralParlourStep(stepIndex, existingApplication) {
        const funeralParlourIsNullValue = this.form.get("funeralParlourForm").get("funeralParlourIsNull").value;
        const funeralParlourIDValue = this.form.get("funeralParlourForm").get("parlourSelector").value;
        if (existingApplication) {
            existingApplication.eLodgementStep = stepIndex;
            existingApplication.funeralParlourId = funeralParlourIsNullValue ? null : funeralParlourIDValue;
        }
        return existingApplication;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
        }
        else
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true
            };
        return application;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
CemeteryStrategyService = CemeteryStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    })
], CemeteryStrategyService);
